import { defineComponent } from 'vue'
import './index.scss'

export default defineComponent({
  name: 'ModuleHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    decoration: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { slots }) {
    return () => (
      <header class="module-header">
        <div class="module-header-main">
          <h2 class="module-header-title">{props.title}</h2>
          {slots.default?.()}
        </div>
        {props.description && <p class="module-header-desc">{props.description}</p>}
        {props.decoration && (
          <svg width="100%" height="5" viewBox="0 0 1440 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 4H1440" stroke="#FFBA00" stroke-miterlimit="10" />
            <path
              d="M1277.48 0H1440V4H1271L1274.24 1.20615C1275.14 0.429117 1276.29 0.000859238 1277.48 0Z"
              fill="#FFBA00"
            />
          </svg>
        )}
      </header>
    )
  }
})
